import script from "./SelectBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectBase.vue?vue&type=script&setup=true&lang=ts"

import "./SelectBase.vue?vue&type=style&index=0&id=02aa4246&lang=css"

const __exports__ = script;

export default __exports__